module.exports = __webpack_public_path__ + "static/media/p-icon-blue.5944522c.svg";